import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const openOverlay = () => document.querySelector('[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"], [role="menu"][data-state="open"], [aria-modal="true"]');

// Suelta bloqueos huérfanos (pointer-events / scroll-lock) cuando ya no hay ningún modal o menú abierto.
const releaseLocks = () => {
  if (openOverlay()) return;
  const b = document.body;
  if (b.style.pointerEvents === "none") b.style.pointerEvents = "";
  if (b.hasAttribute("data-scroll-locked")) b.removeAttribute("data-scroll-locked");
};

// Al navegar hacia adelante a otra ruta, arranca arriba. En "atrás" (POP) respeta la posición del navegador.
export function ScrollToTop() {
  const { pathname } = useLocation();
  const navType = useNavigationType();
  useEffect(() => {
    releaseLocks();
    if (navType !== "POP") window.scrollTo(0, 0);
  }, [pathname, navType]);
  useEffect(() => {
    let t = null;
    const check = () => { clearTimeout(t); t = setTimeout(releaseLocks, 350); };
    const mo = new MutationObserver(check);
    mo.observe(document.body, { attributes: true, attributeFilter: ["style", "data-scroll-locked"], childList: true });
    return () => { mo.disconnect(); clearTimeout(t); };
  }, []);
  return null;
}

export default ScrollToTop;
